import { render, staticRenderFns } from "./GoodsServicesCategory.vue?vue&type=template&id=2ad4eafb&scoped=true&"
import script from "./GoodsServicesCategory.vue?vue&type=script&lang=js&"
export * from "./GoodsServicesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad4eafb",
  null
  
)

export default component.exports